<template>
<content-div>
	<div class="svTitArea subscribe guideInsurance">
		<!-- <div class="titCon">
			<h2 class="svTit">서비스는 공식, 안심도 정식으로</h2>
			<p class="svTitSub">
				합리적인 가격의 차량관리 안심 솔루션<br>
				BMW ServiceCare+
			</p>
		</div> -->
	</div>

	<!-- <div class="sub_copy alignC" style="margin: 10px 0 10px 0;">
		<p class="sub_copy_txt">
			BMW Plus 앱에서 관리하고<br>
			간단하게 서비스를 예약하고 이용하세요.
		</p>
	</div> -->
	<div class="sub_copy alignC" style="margin: 10px 0 10px 0;">
		<p class="sub_copy_txt">
			가입부터 결제까지 디지털로 편안하게<br>
			BMW가 당신의 드라이빙의 즐거움을 더 오래 지켜드립니다.
		</p>
	</div>

	<div class="subBlock" style="margin:0px;"></div>
	
	<div class="contArea" style="margin-bottom:40px;">
		<div class="sub_copy">
			<h3 class="sub_copy_title" style="font-size:18px;">BMW ServiceCare+ 이용 방법.</h3>
		</div>
		
		<ul class="guide_ul" style="">
			<li>
				<img :src="`${$store.state.dir}images/guide/icon0.png`" alt="">
				<dl>
					<dt>1. ServiceCare+ 가입</dt><!--2024-03-11-->
					<dd>Vantage 앱을 통해 ServiceCare+에 가입하세요.</dd>
				</dl>
			</li>
			<li class="arrow_li"><div></div></li>
			<li>
				<img :src="`${$store.state.dir}images/guide/icon1.png`" alt="">
				<dl>
					<dt>2. 실시간 예약</dt>
					<dd>MyBMW 앱에서 서비스를 쉽고 빠르게 예약하세요.</dd>
				</dl>
			</li>
			<li class="arrow_li"><div></div></li>
			<li>
				<img :src="`${$store.state.dir}images/guide/icon2.png`" alt="">
				<dl>
					<dt>3. 차량 정비</dt>
					<dd>
            예약한 일정에 BMW 공식 딜러 서비스 센터를 방문하고 차량 정비를 받으세요.
					</dd>
				</dl>
			</li>
			<li class="arrow_li"><div></div></li>
			<li>
				<img :src="`${$store.state.dir}images/guide/icon3.png`" alt="">
				<dl>
					<dt>4. ServiceCare+ 쿠폰 활용</dt>
					<dd>
            Vantage 앱 > 우측상단 차량관리 > MyService > My ServiceCare+ 메뉴에서 활성화된 쿠폰을 사용하세요.<br>
						<span style="font-size:12px;">(사용한 쿠폰은 영업일 기준 5일 이내로 비활성화 될 예정입니다.)</span>
					</dd>
				</dl>
			</li>
		</ul>

	</div>

	<div class="subBlock" style="margin:0px;"></div>

	<div class="contArea" style="margin-bottom:40px;">
		<div class="sub_copy" >
			<h3 class="sub_copy_title" style="font-size:18px;">{{$store.state.insuranceName.toUpperCase()}} 이용 방법.</h3>
		</div>
				
		<ul class="guide_ul guide_ul1">
			<li>
				<img :src="`${$store.state.dir}images/guide/icon4.png`" alt="">
				<dl>
					<dd>1. BMW 공식 서비스 센터에 방문하여 차량을 점검 받으세요.</dd>
				</dl>
			</li>
			<li class="arrow_li"><div></div></li>
			<li>
				<img :src="`${$store.state.dir}images/guide/icon5.png`" alt="">
				<dl>
					<dd>2. 진단기 검사 진행 후에 가견적서 및 작업지시서를 받으세요.</dd>
				</dl>
			</li>
			<li class="arrow_li"><div></div></li>
			<li>
				<img :src="`${$store.state.dir}images/guide/icon6.png`" alt="">
				<dl>
					<dd>3. 담당 서비스 어드바이저가 사전승인절차를 통해 청구 가능 여부를 확인하여 알려드려요.</dd>
				</dl>
			</li>
			<li class="arrow_li"><div></div></li>
			<li>
				<img :src="`${$store.state.dir}images/guide/icon7.png`" alt="">
				<dl>
					<dd>4. 차량 수리 완료 후, 서비스 센터에 비용을 지급하신 이후에 청구서류를 제출하시면, {{$store.state.insuranceName}} 고객센터에서 수리비용을 환급해 드립니다.</dd>
				</dl>
			</li>
		</ul>

		<div class="sub_copy" style="margin-top:20px;">
			<p class="sub_copy_txt">
				<!-- *차량 상태 검사 결과 {{$store.state.insuranceName}} 사용이 불가한 경우 청구가 반려될 수 있습니다.<br>
				*청구 금액은 서류 검토 완료 후, 영업일 기준 7일 이내에 지급될 예정입니다.<br> -->
				* {{$store.state.insuranceName}} 고객 센터 : <br>
				<span style="margin-left:5px;">- 전화번호 : {{envServer.tell}} / {{envServer.tell2}}</span><br>
				<span style="margin-left:5px;">- 운영시간 : 월 ~ 금: 9시-18시</span><br>
				* 사전 승인 절차에서 {{$store.state.insuranceName}} 사용이 반려될 수 있습니다.<br>
				* 보다 자세한 사항은 서비스 약관을 통해 확인하실 수 있습니다.<br>
				* {{envServer.email}} 해당 이메일 주소로 제출해 주세요.
			</p>
		</div>
	</div>

	<div class="subBlock" style="margin:0px;"></div>

	<div class="power_train_section">
		<div class="sub_copy">
			<h3 class="sub_copy_title" style="padding-left:15px; padding-right:15px;">
				{{$store.state.insuranceName.toUpperCase()}} <br>
				금액 청구 방법.
			</h3>
			<img class="w100Im" :src="`${$store.state.dir}images/guide/insurance-img.png`">
			<p class="sub_copy_txt" style="display: block; padding-left:15px; padding-right:15px;">
				{{$store.state.insuranceName}} 수리 완료 후 청구서류를 제출하시고 수리비를 환급 받으세요.
			</p>
		</div>
	</div>

	<div class="contArea power_train_section">
		<div class="price_boxbox" v-if="item.id > 0">
			<p>■ {{$store.state.insuranceName.toUpperCase()}} 사용 내역</p>
			<p class="price alignL">Power Train 10,000,000원</p>
			<div>
				<table>
					<tbody>
						<tr>
							<th>유효기간</th>
							<td>{{ item.subsc.date_start_insurance | date }} ~ {{ item.subsc.date_stop | date }}  </td>
						</tr>
						<tr>
							<th>사용일자</th>
							<td>{{ item.date_approval | date }}</td>
						</tr>
						<tr>
							<th>사용금액</th>
							<td>{{ String(item.price_with_vat) | currency }}원</td>
						</tr>
						<tr>
							<th>사용지점</th>
							<td>{{item.dealer_cdk.title}} {{item.dealer_agent_cdk.title}}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>

		<div class="">
			<p>■ 청구서류</p>
			<ul>
				<li>
					<div>
						<p>- 청구(위임장 및 동의서) <button v-if="item.id > 0" @click="downloadPOAPdf">(PDF다운로드)</button></p>
						<!-- <p class="file_name">파일명.png</p> -->
					</div>
					<!-- <button>업로드</button> -->
				</li>
				<!-- <li>
					<div>
						<p>- 청구서 <button v-if="item.id > 0" @click="downloadPOAPdfUrl">(PDF다운로드TEST)</button></p>
					</div>
				</li> -->
				<li>
					<p>- 신분증 사본</p>
					<!-- <button>업로드</button> -->
				</li>
				<li>
					<p>- 통장 사본</p>
					<!-- <button>업로드</button> -->
				</li>
				<li>
					<p>- 차량등록증</p>
					<!-- <button>업로드</button> -->
				</li>
				<li>
					<p>- 자동차 검사표</p>
					<!-- <button>업로드</button> -->
				</li>
				<li>
					<p>- 전면 사진<span>(번호판 포함)</span></p>
					<!-- <button>업로드</button> -->
				</li>
				<li>
					<p>- 차량계기판 사진<span>(주행거리 포함)</span></p>
					<!-- <button>업로드</button> -->
				</li>
				<li>
					<p>- 수리 견적서<span>(BMW 공식 딜러 서비스 센터에서 요청)</span></p>
					<!-- <button>업로드</button> -->
				</li>
				<li>
					<p>- 수리비 영수증 <span>(BMW 공식 딜러 서비스 센터에서 요청)</span></p>
					<!-- <button>업로드</button> -->
				</li>
				<li>
					<p>- 대상 부품 수리 전후 사진 <span>(BMW 공식 딜러 서비스 센터에서 요청)</span></p>
					<!-- <button>업로드</button> -->
				</li>
			</ul>

			<!-- <button>보험 청구 서류 전송</button> -->
		</div>
		
		<!-- <div class="cancelRsv alignL" style="margin-bottom:10px;">
			<span class="info2">
				<span>※ 보험금 청구 문의는 보험사 고객센터로 문의 바랍니다.</span><br>
				<span>※ 전화번호 : {{envServer.tell}}</span>
			</span>
		</div> -->
			
		<div class="sub_copy">
			<p class="sub_copy_txt">
				* 단, 가견적을 통한 청구 가능여부와 실제 보상여부는 상이할 수 있으며, 보상의 세부사항은 BMW ServiceCare+ 이용약관을 따릅니다.<br>
				* 청구 금액은 서류 검토 완료 후, 영업일 기준 7일 이내에 지급될 예정입니다.<br>
				* 보험금 청구 문의는 {{$store.state.insuranceName}} 고객센터로 문의 바랍니다.<br>
				* {{$store.state.insuranceName}} 고객 센터 : <br>
				<span style="margin-left:5px;">- 전화번호 : {{envServer.tell}} / {{envServer.tell2}}</span><br>
				<span style="margin-left:5px;">- 운영시간 : 월 ~ 금: 9시-18시</span><br>
				<span style="margin-left:5px;">- 이메일주소 : {{envServer.email}}</span>
			</p>
		</div>
	</div>

	<div class="subBlock" style="margin:0px;"></div>

	<div class="contArea" style="margin-bottom:40px;">
		<div class="sub_copy" >
			<h3 class="sub_copy_title">구독 해지 신청.</h3>
		</div>

		<div class="tglCon">
			<p class="sub_copy_txt">
				구독 해지를 원하실 경우, 아래의 구독 해지 신청 버튼을 터치해주세요.<br><br>
			</p>
				<div class="fullBtn">
					<router-link  class="btnL" :to="`/subscRevoke?vtg_id=`">구독 해지 신청하기</router-link>
				</div>
				<br>
			<p style="text-indent: -20px;margin-left: 20px;">
				※ 구독 해지 시 정산수수료율에 따라 차감 정산해 환급해 드립니다. <br>    
			</p>
			<p>&nbsp;</p>
			<p>&nbsp;</p>
			<p style="line-height: 0.8;">
				<span style="font-size: 8pt;">BMW Korea ㈜는 통신판매중개자이며, 통신판매의 당사자가 아닙니다.&nbsp;</span>
				<span style="font-size: 8pt;">상품, 상품정보, 거래에 관한 의무와 책임은 판매자에게 있습니다.&nbsp;</span>&nbsp;
			</p>
		</div>
	</div>

	<template v-if="transferShow">
		<div class="subBlock" style="margin:0px;"></div>

		<div class="contArea" style="margin-bottom:40px;">
			<div class="sub_copy" >
				<h3 class="sub_copy_title">양수 신청.</h3>
			</div>

			<div class="tglCon">
				<p class="sub_copy_txt">
					양수신청을 원하실 경우 차대번호 입력 후 진행해 주세요.<br><br>
					<input type="text" v-model="numId" maxlength="17"><br><br>
				</p>					
				<div class="fullBtn">
					<a class="btnL" @click="transferVehicle">양수 신청 진행하기</a>
				</div>
				<br>
				<div class="sub_copy" style="margin-top:10px;">
					<div class="sub_copy_txt">
						* 양도 시 주의사항 <br>
						<div class="noticeTxt">
							양수인의 서비스 이용 가능 기간은 최초가입자의 서비스 이용기간과 동일합니다.<br>
							가입 기간의 잔여 서비스 기간이 30일 이상만 양도가 가능합니다.<br>
							양수인은 양도 받은 멤버십에 대해서는 환불이 불가합니다.<br>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="subBlock" style="margin:0px;"></div>
	</template>

<!-- // 컨텐츠 box-->
</content-div>
</template>

<script>
import { mapState } from 'vuex';
import Const from '../../helpers/Const';
import {api} from '@/api';
import axios from 'axios';
import Format from '../../helpers/Format';
import { getToken } from '@/auth'; 


export default {
	name: 'GuideInsurance',
	components:{

	},
	filters: Format,
	
	created () {
		this.getItem();
	},
	data() {
		return {
			Const,
			item:{
				id:0,
			},
			numId: '',
		}
	},
	computed: {
		...mapState({
			envServer: state => state.envServer,
			user: state => state.user,
			btnLoading: state => state.btnLoading,
		}),
		careInsuranceConfirmId() { return this.$route.params.careInsuranceConfirmId; },
		//양수신청 무조건 막기처리
		transferShow(){ return (this.user.vtg_id && this.user.vehicles.length < 0);}

	},
	methods: {
		getItem() {
			if(!this.careInsuranceConfirmId) return;

			axios.get(`${api.careInsuranceConfirms}/${this.careInsuranceConfirmId}`)
			.then(({data}) => {
				this.item = data.data;
			})
			.catch((error) => {
				this.$store.commit('SET_ALERT', { 
					show: true,
					content: this.errorMsg(error),
				});
			})
		},

		downloadPOAPdf() {
			if(!this.careInsuranceConfirmId) return;

			axios({
				url: `${api.careInsuranceConfirms}/downloadPOAPdf/${this.careInsuranceConfirmId}`,
				method: 'GET',
				responseType: 'blob', // important
			})
			.then(res => {
				const url = window.URL.createObjectURL(new Blob([res.data]));
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', 'BMW ServiceCare+.pdf');
				document.body.appendChild(link);
				link.click();
			})
			.catch(error => {
				this.$store.commit('SET_ALERT', { 
					show: true,
					content: this.errorMsg(error),
				});
			});
		},
		transferVehicleValidate(){
			if( !this.user.vtg_id || this.btnLoading ) return;
			this.transferVehicle();
		},

		transferVehicle() {
			this.$store.commit('setBtnLoading', true);
			axios.post(`${api.vehicles}/escalationCheck`, {
				vtg_id: this.user.vtg_id,
				num_id: this.numId,
			})
			.then(({data}) => {

				let submitTransferVehicle = () => {
					this.$store.commit("setUser", { id: data.data.user_id, });
					// this.$router.push({ path: `/transfer/${data.data.subsc_id}` }); 
					this.$router.push({ path: `/transfer/${data.data.subsc_id}` , query: { vtg_id:this.user.vtg_id }}); 
				}
				
				if(this.user.id > 0) {
					submitTransferVehicle();
				} else {
					getToken(this.user.vtg_id, submitTransferVehicle);
				}
			})
			.catch((error) => {

				let errData = { 
					show: true,
					content: this.errorMsg(error),
				}

				if( this.getErrorStatusCode(error) ) {
					switch (this.getErrorStatusCode(error)) {
						case Const.ERROR_CODE.SUBSC_ESCALATION_GO_OAS:
							errData.btn_cancel = true;
							errData.btn_submit_title = '차량등록';
							errData.submit = () => {
								//this.oasRedirect('/bmw/user/vehicle');
								this.vtgRedirect('/bmw/user/vehicle');
							}
							break;
						case Const.ERROR_CODE.UBSC_ESCALATION_GO_SCP:
							errData.btn_cancel = true;
							errData.btn_submit_title = '가입하기';
							errData.submit = () => {
								this.$router.push({ path: `/` , query: { vtg_id: this.user.vtg_id }});
							}
							break;

					}
				}

				this.$store.commit('SET_ALERT', errData);
			})
		},


	},
};
</script>